import { getMessages } from '../../../../../store/constants';

export const CLASS_ACTION_MODAL= 'action-modal';

export const ACTION_MODAL_CANCEL = getMessages().getText('common.cancel');
